export default "__VITE_ASSET__BpXAwjoI__"